module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.user.scope) ? _c('div', [_c('div', {
    staticClass: "headerGroup"
  }, [(_vm.data.question.user.user_id === _vm.user.scope.user_id) ? _c('edit-question-title', {
    attrs: {
      "question-id": _vm.data.question.question_id,
      "title": _vm.data.question.question
    },
    on: {
      "questionUpdated": _vm.questionDidUpdate
    }
  }) : _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.data.question.question))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "thread-date"
  }, [_vm._v(_vm._s(_vm.$t('message.threadAskedBy')) + " "), _c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.data.question.user.profile.url
      }
    }
  }, [_vm._v(_vm._s(_vm.encodeText(_vm.data.question.user.display_name)))]), _vm._v(" on " + _vm._s(_vm.formatDate(_vm.data.question.timestamp)))], 1)], 1), _vm._v(" "), _c('mu-card', [_c('mu-card-text', {
    staticClass: "userCard"
  }, [(!_vm.data.question.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "src": "static/avatar.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.avatar) ? _c('mu-avatar', {
    staticClass: "userImage",
    attrs: {
      "size": 105,
      "src": _vm.data.question.user.avatar
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userBlock"
  }, [_c('div', {
    staticClass: "badges"
  }, [(_vm.data.question.user.is_admin) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.is_mentor) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.is_moderator) ? _c('user-badge', {
    attrs: {
      "type": "support",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.is_champion) ? _c('user-badge', {
    attrs: {
      "type": "champion",
      "mode": "image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.is_complete) ? _c('user-badge', {
    attrs: {
      "type": "finished-program",
      "mode": "image"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        path: '/profile/' + _vm.data.question.user.profile.url
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.encodeText(_vm.data.question.user.display_name)) + " "), (_vm.data.question.user.country.country_id !== 0) ? _c('country-badge', {
    attrs: {
      "alpha2": _vm.data.question.user.country.alpha2,
      "tooltip": _vm.data.question.user.country.country_name
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.data.hcp_question && _vm.data.question.user.is_hcp && _vm.data.question.user.hcp_verified) ? _c('user-badge', {
    staticClass: "hcpBadge",
    attrs: {
      "type": "hcp-verified",
      "mode": "image"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "blueLine",
    domProps: {
      "textContent": _vm._s(_vm.data.hcp_question && _vm.data.question.user.is_hcp ? _vm.data.question.user.hcp_role : _vm.data.question.user.diabetes_type)
    }
  }), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "posts"
  }, [_vm._v(_vm._s(_vm.$t('message.threadPostsCount')) + " " + _vm._s(_vm.data.question.posts))])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "date",
    domProps: {
      "textContent": _vm._s(_vm.formatDate(_vm.data.question.timestamp))
    }
  })])], 1)], 1)], 1), _vm._v(" "), (!_vm.isQuestionEditOpen) ? _c('mu-card-text', [_c('vue-markdown', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "source": _vm.encodeText(_vm.data.question.content || _vm.data.question.question)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isQuestionEditOpen) ? _c('mu-card-text', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateQuestion.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "textarea",
    attrs: {
      "data-vv-scope": "editQuestion",
      "data-vv-name": "question",
      "data-vv-validate-on": "none",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('question'),
      "data-vv-as": _vm.$t('message.labelBody'),
      "labelFloat": false,
      "multiLine": "",
      "rows": 1,
      "rowsMax": 10,
      "hintText": _vm.$t('message.labelBody'),
      "fullWidth": true
    },
    model: {
      value: (_vm.questionEditModel.content),
      callback: function($$v) {
        _vm.$set(_vm.questionEditModel, "content", $$v)
      },
      expression: "questionEditModel.content"
    }
  }), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": _vm.$t('message.cancelText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEditQuestion.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": _vm.$t('message.updateText'),
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateQuestion()
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isQuestionEditOpen) ? _c('div', [(_vm.data.question.likes !== 0) ? _c('mu-card-text', {
    staticClass: "likesCounter",
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.pluralizeUseful(_vm.data.question.likes, _vm.data.question.liked)))
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
    staticClass: "actions",
    attrs: {
      "align": "left"
    }
  }, [((_vm.user.user_role.role_id !== 2 && _vm.data.question.user.is_admin !== true) && _vm.data.question.user.user_id !== _vm.user.scope.user_id) ? _c('mu-flat-button', {
    staticClass: "reportBtn",
    attrs: {
      "color": "#D83E38",
      "disabled": _vm.data.question.reported,
      "icon": "report_problem",
      "label": _vm.data.question.reported ? _vm.$t('message.reportedText') : _vm.$t('message.reportText')
    },
    on: {
      "click": function($event) {
        return _vm.openReport('THREAD_QUESTION', _vm.data.question.question_id)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.user_id !== _vm.user.scope.user_id) ? _c('mu-flat-button', {
    class: {
      active: _vm.data.question.liked
    },
    attrs: {
      "color": "#0179d9",
      "icon": "thumb_up",
      "label": _vm.$t('message.discussionTabUseful'),
      "disabled": _vm.isLiking
    },
    nativeOn: {
      "click": function($event) {
        return _vm.markQuestionUseful.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.user_id === _vm.user.scope.user_id) ? _c('mu-flat-button', {
    attrs: {
      "color": "#0179d9",
      "icon": "edit",
      "label": _vm.$t('message.editText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEditQuestion()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.question.user.user_id === _vm.user.scope.user_id || _vm.user.user_role.role_id === 2) ? _c('mu-flat-button', {
    attrs: {
      "color": "#0179d9",
      "icon": "delete",
      "label": _vm.$t('message.deleteText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteQuestion(_vm.data.question.question_id)
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.data.question.report_count > 0 && _vm.user.user_role.role_id === 2) ? _c('report', {
    attrs: {
      "type": "THREAD_QUESTION",
      "typeId": parseInt(_vm.$route.params.id)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.data.replies.length > 0) ? _c('div', {
    attrs: {
      "id": "replies"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "width": "100",
      "tablet": "50"
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "pagination"
  }, [(_vm.data.replies.length !== 0) ? _c('mu-pagination', {
    attrs: {
      "total": _vm.data.count_replies,
      "current": _vm.page,
      "defaultPageSize": _vm.per_page,
      "pageSize": _vm.per_page
    },
    on: {
      "pageChange": _vm.handlePageChange
    }
  }) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "25",
      "width": "50",
      "tablet": "25"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "underlineFocusClass": "underlineFocus",
      "fullWidth": ""
    },
    model: {
      value: (_vm.orderBy),
      callback: function($$v) {
        _vm.orderBy = $$v
      },
      expression: "orderBy"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": "CHRONOLOGICAL",
      "title": _vm.$t('message.threadChronological')
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "MOST_RECENT",
      "title": _vm.$t('message.threadMostRecent')
    }
  })], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "25",
      "width": "50",
      "tablet": "25"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "scroller": _vm.scroller,
      "underlineFocusClass": "underlineFocus",
      "fullWidth": ""
    },
    on: {
      "change": function($event) {
        return _vm.updatePerPage()
      }
    },
    model: {
      value: (_vm.per_page),
      callback: function($$v) {
        _vm.per_page = $$v
      },
      expression: "per_page"
    }
  }, _vm._l((_vm.pageSizes), function(item, index) {
    return _c('mu-menu-item', {
      key: 'page-size-' + index,
      attrs: {
        "value": item,
        "title": item + ' per page'
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.data.replies), function(thread, index) {
    return _c('mu-row', {
      key: 'reply-' + index
    }, [_c('mu-col', {
      attrs: {
        "desktop": "100",
        "width": "100",
        "tablet": "100"
      }
    }, [_c('mu-card', {
      class: {
        'bottom': index !== (_vm.data.replies.length - 1) && _vm.user.user_role.role_id !== 2 || thread.report_count === 0
      }
    }, [_c('mu-card-text', {
      staticClass: "userCard"
    }, [(!thread.user.avatar) ? _c('mu-avatar', {
      staticClass: "userImage",
      attrs: {
        "size": 105,
        "src": "static/avatar.png"
      }
    }) : _vm._e(), _vm._v(" "), (thread.user.avatar) ? _c('mu-avatar', {
      staticClass: "userImage",
      attrs: {
        "size": 105,
        "src": thread.user.avatar
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "userBlock"
    }, [_c('div', {
      staticClass: "badges"
    }, [(thread.user.is_admin) ? _c('user-badge', {
      attrs: {
        "type": "support",
        "mode": "image"
      }
    }) : _vm._e(), _vm._v(" "), (thread.user.is_mentor) ? _c('user-badge', {
      attrs: {
        "type": "support",
        "mode": "image"
      }
    }) : _vm._e(), _vm._v(" "), (thread.user.is_moderator) ? _c('user-badge', {
      attrs: {
        "type": "support",
        "mode": "image"
      }
    }) : _vm._e(), _vm._v(" "), (thread.user.is_champion) ? _c('user-badge', {
      attrs: {
        "type": "champion",
        "mode": "image"
      }
    }) : _vm._e(), _vm._v(" "), (thread.user.is_complete) ? _c('user-badge', {
      attrs: {
        "type": "finished-program",
        "mode": "image"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('router-link', {
      attrs: {
        "to": {
          path: '/profile/' + thread.user.profile.url
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.encodeText(thread.user.display_name)) + " "), (thread.user.country.country_id !== 0) ? _c('country-badge', {
      attrs: {
        "alpha2": thread.user.country.alpha2,
        "tooltip": thread.user.country.country_name
      }
    }) : _vm._e()], 1), _vm._v(" "), (_vm.data.hcp_question && thread.user.is_hcp && thread.user.hcp_verified) ? _c('user-badge', {
      staticClass: "hcpBadge",
      attrs: {
        "type": "hcp-verified",
        "mode": "image"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "blueLine",
      domProps: {
        "textContent": _vm._s(_vm.data.hcp_question && thread.user.is_hcp ? thread.user.hcp_role : thread.user.diabetes_type)
      }
    }), _vm._v(" "), _c('mu-row', [_c('mu-col', {
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "50"
      }
    }, [_c('div', {
      staticClass: "posts"
    }, [_vm._v(_vm._s(_vm.$t('message.threadPostsCount')) + " " + _vm._s(thread.posts))])]), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "50"
      }
    }, [_c('div', {
      staticClass: "date",
      domProps: {
        "textContent": _vm._s(_vm.formatDate(thread.timestamp))
      }
    })])], 1)], 1)], 1), _vm._v(" "), _vm._l((thread.answer_quotes), function(reply, index) {
      return (reply.display_name) ? _c('mu-card-text', {
        key: 'reply' + index,
        staticClass: "quotes"
      }, [_c('mu-card', [_c('mu-card-header', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.$sanitize(reply.display_name + ' ' + _vm.$t('message.threadUserSaid') + ' &uarr;'))
        }
      })]), _vm._v(" "), _c('mu-card-text', [_c('vue-markdown', {
        attrs: {
          "source": _vm.$sanitize(reply.answer.substr(0, 300) + ' ...')
        }
      })], 1)], 1)], 1) : _vm._e()
    }), _vm._v(" "), _c('mu-card-text', [(!thread.editOpen) ? _c('vue-markdown', {
      staticStyle: {
        "white-space": "pre-wrap"
      },
      attrs: {
        "source": _vm.escape(_vm.$sanitize(thread.answer))
      }
    }) : _vm._e()], 1), _vm._v(" "), (thread.editOpen) ? _c('mu-card-text', [_c('form', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "data-vv-scope": "updateAnswer"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.updateAnswer(thread)
        }
      }
    }, [(thread.editOpen) ? _c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required|min:5'),
        expression: "'required|min:5'"
      }],
      staticClass: "textarea",
      attrs: {
        "id": 'reply-' + thread.answer_id,
        "data-vv-validate-on": "none",
        "data-vv-name": 'reply-' + thread.answer_id,
        "data-vv-value-path": "inputValue",
        "data-vv-as": _vm.$t('message.labelBody'),
        "errorText": _vm.errors.first('reply-' + thread.answer_id),
        "labelFloat": false,
        "multiLine": "",
        "rows": 1,
        "rowsMax": 10,
        "hintText": _vm.$t('message.replyToText') + ' ' + thread.user.display_name,
        "fullWidth": true,
        "readonly": _vm.isSaving,
        "disabled": _vm.isSaving
      },
      model: {
        value: (thread.editableReply),
        callback: function($$v) {
          _vm.$set(thread, "editableReply", $$v)
        },
        expression: "thread.editableReply"
      }
    }) : _vm._e(), _vm._v(" "), _c('mu-flat-button', {
      attrs: {
        "label": _vm.$t('message.discardText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.discardEdit(thread)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "submit"
      }
    }), _vm._v(" "), _c('mu-raised-button', {
      attrs: {
        "secondary": "",
        "disabled": thread.isUpdating,
        "label": thread.isUpdating ? _vm.$t('message.updatingText') + '...' : _vm.$t('message.updateText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.updateAnswer(thread)
        }
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (thread.likes !== 0) ? _c('mu-card-text', {
      staticClass: "likesCounter",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.pluralizeUseful(thread.likes, thread.liked)))
      }
    }) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
      staticClass: "actions",
      attrs: {
        "align": "left"
      }
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v("#" + _vm._s(_vm.getPageIndex(index)))]), _vm._v(" "), ((_vm.user.user_role.role_id !== 2 && thread.user.is_admin !== true) && thread.user.user_id !== _vm.user.scope.user_id) ? _c('mu-flat-button', {
      staticClass: "reportBtn",
      attrs: {
        "color": "#D83E38",
        "disabled": thread.reported,
        "icon": "report_problem",
        "label": thread.reported ? _vm.$t('message.reportedText') : _vm.$t('message.reportText')
      },
      on: {
        "click": function($event) {
          return _vm.openReport('THREAD_ANSWER', thread.answer_id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.user.scope.user_id !== thread.user.user_id) ? _c('mu-flat-button', {
      class: {
        active: thread.liked
      },
      attrs: {
        "color": "#0179d5",
        "icon": "thumb_up",
        "label": _vm.$t('message.discussionTabUseful'),
        "disabled": thread.isLiking
      },
      nativeOn: {
        "click": function($event) {
          return _vm.markUseful(thread)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.user.scope.user_id === thread.user.user_id) ? _c('mu-flat-button', {
      attrs: {
        "color": "#0179d5",
        "icon": "edit",
        "label": "Edit"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.editAnswer(thread)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.user.scope.user_id === thread.user.user_id || _vm.user.user_role.role_id === 2) ? _c('mu-flat-button', {
      attrs: {
        "color": "#0179d5",
        "icon": "delete",
        "label": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteAnswer(thread, thread.answer_id)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('mu-flat-button', {
      attrs: {
        "color": "#0179d5",
        "icon": "reply",
        "label": _vm.capitalize(_vm.$t('message.replyText'))
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggleReplyPanel(thread)
        }
      }
    })], 1), _vm._v(" "), (thread.replyOpen) ? _c('mu-card-text', [_c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "textarea",
      attrs: {
        "id": 'reply-' + thread.answer_id,
        "data-vv-name": 'reply-' + thread.answer_id,
        "data-vv-value-path": "inputValue",
        "errorText": _vm.errors.first('reply-' + thread.answer_id),
        "data-vv-as": _vm.$t('message.labelBody'),
        "labelFloat": false,
        "multiLine": "",
        "rows": 1,
        "rowsMax": 10,
        "hintText": _vm.$store.state.status.payment.paid ? _vm.$t('message.replyToText') + ' ' + thread.user.display_name : 'Only premium users can answer a question',
        "fullWidth": true,
        "readonly": _vm.isSaving,
        "disabled": _vm.isSaving
      },
      model: {
        value: (thread.replyable),
        callback: function($$v) {
          _vm.$set(thread, "replyable", $$v)
        },
        expression: "thread.replyable"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (thread.replyOpen),
        expression: "thread.replyOpen"
      }],
      attrs: {
        "align": "right"
      }
    }, [_c('mu-flat-button', {
      attrs: {
        "label": _vm.$t('message.discardText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggleReplyPanel(thread)
        }
      }
    }), _vm._v(" "), _c('mu-flat-button', {
      attrs: {
        "color": "white",
        "backgroundColor": "#7CBE30",
        "label": thread.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.submitText'),
        "disabled": thread.isSaving || !_vm.$store.state.status.payment.paid
      },
      nativeOn: {
        "click": function($event) {
          return _vm.replyToAnswer(thread)
        }
      }
    })], 1)], 2), _vm._v(" "), (thread.report_count > 0 && _vm.user.user_role.role_id === 2) ? _c('report', {
      attrs: {
        "type": "THREAD_ANSWER",
        "typeId": thread.answer_id
      }
    }) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [(_vm.data.replies.length !== 0) ? _c('mu-pagination', {
    staticClass: "top",
    attrs: {
      "total": _vm.data.count_replies,
      "current": _vm.page,
      "defaultPageSize": _vm.per_page,
      "pageSize": _vm.per_page
    },
    on: {
      "pageChange": _vm.handlePageChange
    }
  }) : _vm._e()], 1)], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.data.replies.length === 0) ? _c('mu-card', {
    staticClass: "top"
  }, [_c('mu-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('message.threadAnswersEmpty')) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navigate"
  }, [(_vm.data.prev) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'QuestionThread',
        params: {
          id: _vm.data.prev
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.threadPreviousQuestion')))]) : _vm._e(), _vm._v(" "), (_vm.data.prev != 0 && _vm.data.next != 0) ? _c('span', {
    staticClass: "sep"
  }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), (_vm.data.next) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'QuestionThread',
        params: {
          id: _vm.data.next
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.threadNextQuestion')))]) : _vm._e()], 1), _vm._v(" "), _c('form', {
    attrs: {
      "id": "submitReplyForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveAnswer.apply(null, arguments)
      }
    }
  }, [_c('mu-card', [_c('mu-card-text', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "textarea",
    attrs: {
      "data-vv-name": "answer",
      "data-vv-value-path": "inputValue",
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('message.labelBody'),
      "errorText": _vm.errors.first('answer'),
      "labelFloat": false,
      "multiLine": "",
      "rows": 3,
      "rowsMax": 6,
      "hintText": _vm.$store.state.status.payment.paid ? _vm.$t('message.threadInputPlaceholder') : 'Only premium users can ask a question',
      "fullWidth": "",
      "readonly": _vm.isSaving,
      "disabled": _vm.isSaving
    },
    model: {
      value: (_vm.model.answer),
      callback: function($$v) {
        _vm.$set(_vm.model, "answer", $$v)
      },
      expression: "model.answer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "action"
  }, [_c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "backgroundColor": "#3d8517",
      "color": "white",
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.threadSubmitReplyText'),
      "disabled": _vm.isSaving || !_vm.$store.state.status.payment.paid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveAnswer.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.activeReport.type && _vm.activeReport.type_id) ? _c('report-modal', {
    attrs: {
      "open": _vm.activeReport.open,
      "type": _vm.activeReport.type,
      "type_id": _vm.activeReport.type_id
    },
    on: {
      "onClose": function($event) {
        _vm.activeReport.open = false
      },
      "onComplete": function($event) {
        return _vm.setReported(_vm.activeReport)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticStyle: {
      "margin-top": "34px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#1FA3FF",
      "size": 40
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isNewMessage) ? _c('mu-snackbar', {
    attrs: {
      "message": "1 new reply - reload the page?",
      "action": _vm.$t('message.okText'),
      "actionColor": "#1FA3FF"
    },
    on: {
      "actionClick": function($event) {
        return _vm.loadData({
          page: 1,
          per_page: 10,
          latest: 'true'
        }, true)
      },
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), (_vm.answerRemoved) ? _c('mu-toast', {
    attrs: {
      "message": "Your answer was removed"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d7b4c9a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Questions/QuestionThread.vue
// module id = 3106
// module chunks = 1